import axios from 'axios';
import {
  LOGIN_GET_FEATURES_BEGIN,
  LOGIN_GET_FEATURES_SUCCESS,
  LOGIN_GET_FEATURES_FAILURE,
  LOGIN_GET_FEATURES_DISMISS_ERROR,
} from './constants';

export function getFeatures(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: LOGIN_GET_FEATURES_BEGIN,
    });
    //change
    // const token = process.env.REACT_APP_TOKEN;
    const options = {
      headers: {
        // 'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const promise = new Promise((resolve, reject) => {
      //change
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}features/all/`,
        options,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: LOGIN_GET_FEATURES_SUCCESS,
            data: res.data,
          });
          resolve(res);
          // console.log("get features action", res);
        },
        (err) => {
          dispatch({
            type: LOGIN_GET_FEATURES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetFeaturesError() {
  return {
    type: LOGIN_GET_FEATURES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_GET_FEATURES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getFeaturesPending: true,
        getFeaturesError: null,
      };

    case LOGIN_GET_FEATURES_SUCCESS:
      // The request is success
      return {
        ...state,
        getFeaturesPending: false,
        getFeaturesError: null,
        features: action.data,
      };

    case LOGIN_GET_FEATURES_FAILURE:
      // The request is failed
      return {
        ...state,
        getFeaturesPending: false,
        getFeaturesError: action.data.error,
      };

    case LOGIN_GET_FEATURES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getFeaturesError: null,
      };

    default:
      return state;
  }
}
